import { StepCard } from '@/components/step-card';

const STEPS = [
  {
    step: 1,
    title: 'Integra el snippet',
    description:
      'Copia una línea de JavaScript en tu portal. Sin modificar contenidos ni estructura del sitio.',
  },
  {
    step: 2,
    title: 'Configura desde el admin',
    description:
      'Ajusta secciones a leer, idiomas, pronunciación y estilos del widget desde el panel de administración.',
  },
  {
    step: 3,
    title: 'Listo para usar',
    description:
      'Tus usuarios ya pueden escuchar el contenido del portal con un solo clic. Multi-dispositivo y multi-navegador.',
  },
] as const;

export function HowItWorksSection() {
  return (
    <section
      id="how-it-works"
      className="py-20 sm:py-28 bg-peninsula-silver"
      aria-labelledby="how-it-works-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 id="how-it-works-heading" className="text-3xl font-bold tracking-tight sm:text-4xl">
            Tres pasos. Nada más.
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Integra el servicio de vocalización en tu portal en minutos.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-12 sm:grid-cols-3 sm:gap-8">
          {STEPS.map((step) => (
            <StepCard
              key={step.step}
              step={step.step}
              title={step.title}
              description={step.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
